import React from "react";
import ReactDOM from "react-dom/client";
import "./components/GlobalStyle/GlobalStyle.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createStore } from "redux";
import { allReducers } from "./reducer/index";
import { Provider } from "react-redux";
import { UserProvider } from "./context/userContext";
import { OffersProvider } from "./context/offersContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
const store = createStore(allReducers);

root.render(
  <Provider store={store}>
    <UserProvider>
      <OffersProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </OffersProvider>
    </UserProvider>
  </Provider>
);
reportWebVitals();
